export var PIPELINE_FAMILY = {
    start: 'capsuleStart',
    end: 'capsuleEnd',
    process: 'process',
    subprocess: 'subprocess',
    activity: 'activity',
    operation: 'operation',
    task: 'taskBox',
    serviceTask: 'serviceTask',
    userTask: 'userTask',
    manualTask: 'manualTask',
    scriptTask: 'scriptTask',
    businessRule: 'businessRule',
    decision: 'diamond',
    gateway: 'diamond',
    exclusiveGateway: 'gatewayX',
    parallelGateway: 'gatewayPlus',
    inclusiveGateway: 'gatewayCircle',
    event: 'circleEvent',
    timer: 'timer',
    message: 'message',
    signal: 'signal',
    error: 'error',
    exception: 'exception',
    trigger: 'trigger',
    input: 'chevronIn',
    output: 'chevronOut',
    source: 'source',
    destination: 'destination',
    connector: 'arrow',
    arrow: 'arrow',
    flow: 'flowPath',
    pipeline: 'pipelineFlow',
    queue: 'stack',
    buffer: 'buffer',
    merge: 'gatewayMerge',
    fork: 'fork',
    join: 'join',
    split: 'split',
    loop: 'loop',
    retry: 'retry',
    delay: 'timer',
    wait: 'wait',
    synchronization: 'synchronization',
    dependency: 'dependency',
    reference: 'document',
    link: 'linkChain',
    annotation: 'annotation',
    comment: 'comment',
    document: 'document',
    folder: 'folder',
    file: 'file',
    database: 'cylinder',
    dataStore: 'cylinder',
    dataObject: 'dataObject',
    dataset: 'dataset',
    report: 'report',
    dashboard: 'chart',
    log: 'log',
    metric: 'metric',
    kpi: 'kpi',
    analytics: 'analytics',
    alert: 'warning',
    notification: 'notification',
    email: 'email',
    phone: 'phone',
    chat: 'chat',
    api: 'api',
    webhook: 'webhook',
    eventBus: 'eventBus',
    messageQueue: 'messageQueue',
    broker: 'broker',
    service: 'hexService',
    microservice: 'microservice',
    module: 'module',
    package: 'package',
    library: 'library',
    repository: 'git',
    branch: 'branch',
    mergeRequest: 'mergeRequest',
    pullRequest: 'mergeRequest',
    cicd: 'cicd',
    build: 'build',
    compile: 'compile',
    artifact: 'artifact',
    deploy: 'deploy',
    release: 'release',
    rollback: 'rollback',
    environment: 'env',
    development: 'env',
    testing: 'env',
    qa: 'env',
    staging: 'env',
    production: 'env',
    monitoring: 'monitoring',
    authentication: 'shield',
    authorization: 'authorization',
    encryption: 'encryption',
    firewall: 'firewall',
    security: 'shield',
    secretVault: 'secretVault',
    user: 'person',
    customer: 'customer',
    client: 'customer',
    operator: 'operator',
    engineer: 'engineer',
    technician: 'technician',
    manager: 'manager',
    team: 'people',
    department: 'people',
    vendor: 'vendor',
    supplier: 'vendor',
    stakeholder: 'person',
    approval: 'approval',
    review: 'review',
    validation: 'validation',
    verification: 'verification',
    inspection: 'inspection',
    audit: 'document',
    signOff: 'signOff',
    requirement: 'document',
    specification: 'document',
    standard: 'document',
    policy: 'document',
    goal: 'goal',
    objective: 'objective',
    scope: 'document',
    charter: 'document',
    milestone: 'milestone',
    phase: 'phase',
    sprint: 'sprint',
    timeline: 'timeline',
    calendar: 'calendar',
    schedule: 'calendar',
    project: 'folder',
    program: 'folder',
    portfolio: 'folder',
    budget: 'coin',
    cost: 'coin',
    expense: 'coin',
    invoice: 'document',
    payment: 'coin',
    risk: 'risk',
    issue: 'issue',
    blocker: 'error',
    changeRequest: 'change',
    changeOrder: 'change',
    version: 'version',
    revision: 'tag',
    configuration: 'wrench',
    asset: 'crate',
    resource: 'crate',
    machine: 'machine',
    workstation: 'workstation',
    robot: 'robot',
    conveyor: 'conveyor',
    assemblyStation: 'assembly',
    cncMachine: 'cnc',
    productionLine: 'productionLine',
    manufacturingCell: 'manufacturingCell',
    warehouse: 'warehouse',
    inventory: 'inventory',
    storage: 'pallet',
    rawMaterial: 'rawMaterial',
    workInProgress: 'wip',
    finishedGoods: 'finishedGoods',
    scrap: 'scrap',
    waste: 'waste',
    rework: 'change',
    packaging: 'packaging',
    pallet: 'pallet',
    cargoContainer: 'cargoContainer',
    truck: 'truck',
    loadingDock: 'loadingDock',
    forklift: 'forklift',
    agv: 'agv',
    crane: 'crane',
    maintenance: 'wrench',
    repair: 'repair',
    calibration: 'calibration',
    measurement: 'sensor',
    qualityControl: 'qualityControl',
    qualityAssurance: 'qualityAssurance',
    testBench: 'testBench',
    functionalTest: 'functionalTest',
    integrationTest: 'integrationTest',
    unitTest: 'unitTest',
    performanceTest: 'chart',
    reliabilityTest: 'reliabilityTest',
    acceptanceTest: 'acceptanceTest',
    prototype: 'prototype',
    simulation: 'simulation',
    cadModel: 'cadModel',
    schematic: 'schematicDoc',
    blockDiagram: 'blockDiagram',
    bom: 'bom',
    plc: 'system',
    hmi: 'system',
    scada: 'system',
    mes: 'system',
    erp: 'system',
    crm: 'system',
    hrms: 'system',
    sensor: 'sensor',
    camera: 'camera',
    scanner: 'scanner',
    barcodeReader: 'barcode',
    rfidReader: 'rfid',
    iotDevice: 'iot',
    cloud: 'cloud',
    server: 'server',
    virtualMachine: 'vm',
    appContainer: 'appContainer',
    kubernetesCluster: 'k8s',
    edgeDevice: 'iot',
    storageSystem: 'cylinder',
    backup: 'backup',
    archive: 'folder',
    aiAgent: 'ai',
    automation: 'ai',
    workflow: 'workflow',
    businessProcess: 'businessProcess',
    manufacturingProcess: 'manufacturingProcess',
    engineeringProcess: 'engineeringProcess',
    softwareProcess: 'softwareProcess',
    valueStream: 'valueStream',
    controlPoint: 'pin',
    checkpoint: 'checkpoint',
    decisionPoint: 'decisionPoint',
    escalation: 'escalation',
    compliance: 'compliance',
    certification: 'certification',
    customerDelivery: 'customerDelivery',
    handover: 'handover',
    closure: 'capsuleEnd',
    success: 'check',
    failure: 'error',
    warning: 'warning',
    information: 'info',
    priority: 'flag',
    tag: 'tag',
    label: 'tag',
    group: 'lane',
    swimlane: 'lane',
    lane: 'lane',
    pool: 'pool',
    region: 'lane',
    zone: 'lane',
    externalSystem: 'globe',
    thirdPartyService: 'globe',
    internet: 'globe',
    archiveStorage: 'archiveStorage',
    factory: 'factory',
    building: 'building',
    home: 'home',
    school: 'school',
    stadium: 'stadium',
    shop: 'shop',
    market: 'market',
    park: 'park',
    parking: 'parking',
    temple: 'temple',
    staircase: 'staircase',
    lift: 'lift',
    window: 'window',
    car: 'car',
    van: 'van',
    bike: 'bike',
    cycle: 'cycle',
    rickshaw: 'rickshaw',
    autoVehicle: 'autoVehicle',
    bus: 'bus',
    ship: 'ship',
    boat: 'boat',
    flight: 'flight',
    helicopter: 'helicopter',
    road: 'road',
    earth: 'earth',
    star: 'starMark',
    sun: 'sun',
    plant: 'plant',
    forest: 'forest',
    hillStation: 'hillStation',
    solarPanel: 'solarPanel',
    map: 'map',
    laptop: 'laptop',
    gps: 'gps',
    phoneTower: 'phoneTower',
    wifi: 'wifi',
    light: 'light',
    bluetooth: 'bluetooth',
    umbrella: 'umbrella',
    dollar: 'dollar',
    euro: 'euro',
    rupee: 'rupee',
    envelope: 'envelope',
    virus: 'virus',
    bug: 'bug',
    insect: 'insect',
};
export var ENV_MARK = {
    environment: 'ENV',
    development: 'DEV',
    testing: 'TEST',
    qa: 'QA',
    staging: 'STG',
    production: 'PROD',
};
export var SYSTEM_MARK = {
    plc: 'PLC',
    hmi: 'HMI',
    scada: 'SCADA',
    mes: 'MES',
    erp: 'ERP',
    crm: 'CRM',
    hrms: 'HR',
};
